//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getInfo } from "@/api/my";
import { iosLogin, androidLogin } from "@/api/login";
import store from "./store/index.js";
import global from "./assets/js/global";
export default {
  name: "App",
  data() {
    return {
      deviceId: "",
      transitionState: false,
      transitionName: "pop",
      isShowTabBar: false,
      exitapp_status: 0,
      title: "百事通",
      includes: ["home", "create", "invite", "mine", "subscribe"],
      userInfo: {},
    };
  },
  beforeCreate() {
    console.log("app beforeCreate");
  },
  created() {
    console.log("app created");
    var _self = this;
    if (global.isApp) {
      if (api.systemType === "ios") {
        localStorage.setItem("showAgree", "1");
      }
      let agreed = localStorage.getItem("showAgree");
      if (agreed === "1" || agreed === 1) {
        console.log("agree = 1");
        this.showTabBar();
        // this.checkStorege()
        this.appInit();
      }
      this.$bus.on("doDeviceLogin", (value) => {
        console.log("doDeviceLogin: ", value);
      });
      this.$bus.on("showAgree", (value) => {
        console.log("showAgree = 1");
        this.showTabBar();
        this.checkStorege();
        this.appInit();
      });
      // this.userInfo = JSON.parse($api.getStorage('userInfo')) || {}
    } else {
      if (this.$route.query.out_trade_no) {
        this.$bus.emit("showConfirm", true);
      }
      if (this.$route.query.inviteCode) {
        localStorage.setItem("inviteCode", this.$route.query.inviteCode);
      }
      this.showTabBar();
      if (!localStorage.getItem("uuid")) {
        let uuid = this.getUuid();
        console.log(uuid);
        localStorage.setItem("uuid", uuid);
      }
      this.userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
    }
  },
  mounted() {
    console.log("APP Mounted");
    this.$navigation.on('forward', () => {
      this.transitionName = 'push'
    })
    this.$navigation.on('back', () => {
      this.transitionName = 'pop'
    })
    this.$navigation.on('replace', () => {
      this.transitionName = 'pop'
    })
  },
  watch: {
    //使用watch 监听$router的变化
    $route(to, from) {
      window.scroll(0, 0);
      this.showTabBar();
      if (global.isApp) {
        // if ($api.getStorage('token')) {
        var systemType = api.systemType;
        if (systemType !== "ios") {
          // api.setWinAttr({
          // 	slidBackEnabled: false,
          // })
          // this.checkPermission('storage', '应用需要您的授权存储权限才能继续使用')
        }
        // }
      }
      let isBack = this.$store.state.routerState.isBack;
      let isReplace = this.$store.state.routerState.isReplace;
      if (isReplace) {
        // console.log('登录，退出', to.name)
        if (to.name === "home") {
          this.includes = ["home", "create", "invite", "mine"];
        } else if (to.name === "login") {
          this.includes = ["login"];
        }
        this.transitionName = "";
      } else {
        if (isBack) {
          this.transitionName = "pop";
          const i = this.getArrayIndex(this.includes, from.name);
          if (i != -1) {
            this.includes.splice(i, 1);
          }
        } else {
          this.transitionName = "push";
          this.includes.push(to.name);
        }
      }
      console.log(global.isApp);
      console.log("includes: ", this.includes);
    },
  },
  methods: {
    getUuid() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    checkStorege() {
      if (global.isApp) {
        var systemType = api.systemType;
        if (systemType !== "ios") {
          this.checkPermission(
            "storage",
            "应用需要您的授权存储权限才能继续使用"
          );
        }
      }
    },
    // saveUuid () {
    //   console.log('android deviceId:', api.deviceId)
    //   var fs = api.require('fs');
    //   var fsDir = api.fsDir;
    //   console.log('fsDir:', fsDir)
    //   // console.log('fsDir:', fsDir)
    //   console.log('saveUuid:', fs);
    //   let _this = this
    //   fs.exist({
    //     path: '/storage/emulated/0/chat.txt'
    //   }, function (ret, err) {
    //     console.log('exist', ret.exist, JSON.stringify(err))
    //     if (ret.exist) {
    //       if (ret.directory) {
    //         console.log('文件夹存在');
    //       } else {
    //         _this.openFile(fs, true)
    //         console.log('文件存在');
    //       }
    //     } else {
    //       _this.createFile(fs)
    //       console.log('不存在chat.txt文件 :', JSON.stringify(err));
    //     }
    //   });
    // },
    // createFile (fs) {
    //   let _this = this
    //   console.log('创建文件')
    //   fs.createFile({
    //     path: '/storage/emulated/0/chat.txt'
    //   }, function (ret, err) {
    //     console.log('创建文件：', JSON.stringify(ret))
    //     if (ret.status) {
    //       _this.openFile(fs, false)
    //     } else {
    //       console.log('创建文件失败', JSON.stringify(err));
    //     }
    //   });
    // },
    // openFile (fs, isRead) {
    //   let _this = this
    //   var fs = api.require('fs');
    //   fs.open({
    //     path: '/storage/emulated/0/chat.txt',
    //     flags: 'read_write'
    //   }, function (ret, err) {
    //     if (ret.status) {
    //       if (isRead) {
    //         console.log('读文件', JSON.stringify(ret))
    //         _this.readFile(fs, ret.fd)
    //       } else {
    //         console.log('写文件', JSON.stringify(ret))
    //         _this.writeFile(fs, ret.fd)
    //       }

    //     } else {
    //       console.log('打开文件失败', JSON.stringify(err));
    //     }
    //   });
    // },
    // writeFile (fs, fd) {
    //   let _this = this
    //   fs.write({
    //     fd: fd,
    //     data: api.deviceId,
    //     offset: 0
    //   }, function (ret, err) {
    //     if (ret.status) {
    //       console.log('写入文件成功', JSON.stringify(ret));
    //       localStorage.setItem('deviceId', api.deviceId)
    //     } else {
    //       console.log('写入文件失败', JSON.stringify(err));
    //     }
    //   });
    // },
    // readFile (fs, fd) {
    //   let _this = this
    //   fs.read({
    //     fd: fd
    //   }, function (ret, err) {
    //     if (ret.status) {
    //       console.log(JSON.stringify(ret));
    //       localStorage.setItem('deviceId', ret.data)
    //       _this.getUser()
    //       console.log('读取deviceId：', localStorage.getItem('deviceId'))
    //     } else {
    //       console.log('读取文件失败', JSON.stringify(err));
    //       _this.writeFile(fs, fd)
    //     }
    //   });
    // },
    appInit() {
      let _self = this;
      var systemType = api.systemType;
      global.systemType = systemType;
      if (systemType !== "ios") {
        _self.exitApp(); //监听安卓返回键
        _self.doAndroidLogin(); //安卓设备号登录
      } else {
        console.log("Ios 初始化");
        // if (localStorage.getItem('deviceId')) {
        //   var keychain = api.require('keychain');
        //   keychain.delete({
        //     username: 'chat',
        //     serviceName: 'com.gaoshan.chat',
        //   }, function (ret) {
        //     if (ret.status) {
        //       console.log('删除keychain成功')
        //     } else {
        //       console.log('删除keychain失败')
        //     }
        //   });
        // }
        if (localStorage.getItem("deviceId")) {
          // 本地有deviceId 直接去设备号登录 拿最新的token
          this.doIosLogin();
        } else {
          // 本地没有deviceId 去keyChain里找
          var keychain = api.require("keychain");
          console.log("keychain: ", keychain);
          try {
            let _this = this;
            keychain.check(
              {
                username: "chat",
                serviceName: "com.gaoshan.chat",
              },
              function(ret) {
                if (ret.status) {
                  // keychain 已经存储了deviceId
                  console.log("已经存储了keychain", ret.password);
                  localStorage.setItem("deviceId", ret.password);
                  _this.doIosLogin();
                } else {
                  // keychain 没有存储deviceId 去添加
                  let deviceId = api.deviceId;
                  keychain.add(
                    {
                      username: "chat",
                      serviceName: "com.gaoshan.chat",
                      password: deviceId,
                    },
                    function(ret) {
                      if (ret.status) {
                        console.log("添加keychain", deviceId);
                        localStorage.setItem("deviceId", deviceId);
                        _this.doIosLogin();
                      }
                    }
                  );
                }
              }
            );
          } catch (error) {
            api.toast({
              msg: JSON.stringify(error),
              duration: 2000,
              location: "center",
            });
          }
        }
      }
      var header = document.querySelector(".van-nav-bar");
      $api.fixIos7Bar(header);
      $api.fixStatusBar(header);
    },
    doIosLogin() {
      let token = localStorage.getItem("token");
      if (!token) {
        iosLogin({
          udid: localStorage.getItem("deviceId"),
        }).then((res) => {
          localStorage.setItem("token", res.data.token);
          this.getUser();
        });
      }
    },
    doAndroidLogin() {
      let wxToken = localStorage.getItem("wxToken");
      console.log("wxToken:", wxToken);
      let deviceId = localStorage.getItem("deviceId");
      if (!wxToken) {
        console.log("移除旧Token:", localStorage.getItem("token"));
        localStorage.removeItem("token");
        if (!deviceId) {
          deviceId = api.deviceId;
          localStorage.setItem("deviceId", deviceId);
        }
        androidLogin({
          udid: deviceId,
        }).then((res) => {
          localStorage.setItem("token", res.data.token);
          console.log("新Token:", localStorage.getItem("token"));
          this.getUser();
        });
      }
    },
    getUser() {
      if (!localStorage.getItem("deviceId")) {
        return;
      }
      console.log("app: info");
      getInfo().then((res) => {
        if (res && res.data && res.data.unionId) {
          localStorage.setItem("unionId", res.data.unionId);
        } else {
          localStorage.removeItem("wxToken");
          localStorage.removeItem("unionId");
        }
      });
    },
    /*
     * 获取某个元素下标
     * arr: 传入的数组
     * obj: 需要获取下标的元素
     * */
    getArrayIndex(arr, obj) {
      var i = arr.length;
      while (i--) {
        if (arr[i] === obj) {
          return i;
        }
      }
      return -1;
    },
    checkPermission(per, msg) {
      var permission = per;
      console.log("JS", api);
      var resultList = api.hasPermission({
        list: [permission],
      });
      if (resultList[0].granted) {
        console.log("已设置存储权限1");
        // if (!localStorage.getItem('deviceId')) {
        // this.saveUuid()
        // }
      } else {
        console.log("设置");
        // let _this = this
        // Dialog.confirm({
        // 	title: '提示',
        // 	message: msg,
        // 	confirmButtonColor: '#30b8b8',
        // 	confirmButtonText: '去设置',
        // 	cancelButtonText: '取消',
        // 	cancelButtonColor: '#999999',
        // })
        // 	.then(() => {})
        // 	.catch(() => {
        // 		api.closeWidget({
        // 			id: 'A6150791471563',
        // 			silent: true,
        // 		})
        // 	})
        let _this = this;
        api.confirm(
          {
            msg: msg,
            buttons: ["取消", "去设置"],
          },
          function(ret) {
            // 1.取消 2.设置
            if (ret.buttonIndex == 2) {
              let _self = _this;
              api.requestPermission(
                {
                  list: [permission],
                },
                function(res) {
                  if (res.list[0].granted) {
                    // _self.saveUuid()
                  } else {
                    // api.closeWidget({
                    //   id: 'A6122368097326',
                    //   silent: true,
                    // })
                  }
                }
              );
            } else {
              // api.closeWidget({
              //   id: 'A6122368097326',
              //   silent: true,
              // })
            }
          }
        );
      }
    },
    showTabBar() {
      if (global.isApp) {
        if (!localStorage.getItem("showAgree")) {
          return;
        }
      }
      const name = this.$route.name;
      if (name === "home" || name === "create" || name === "mine") {
        this.exitapp_status = 1;
        // if (name !== 'login') {
        store.commit("changeInds", this.$route.meta.inds);
        this.isShowTabBar = true;
        // } else {
        //   this.isShowTabBar = false
        //   this.includes = ['login']
        // }
      } else {
        this.exitapp_status = 0;
        this.isShowTabBar = false;
      }
    },
    getTitle(title) {
      this.title = title;
    },
    exitApp() {
      var _self = this;
      api.addEventListener(
        {
          name: "keyback",
        },
        function(ret, err) {
          console.log("aaa", _self.exitapp_status);
          if (_self.exitapp_status == 1) {
            api.toast({
              msg: "再次点击返回键退出APP",
              duration: 2000,
              location: "bottom",
            });
            api.addEventListener(
              {
                name: "keyback",
              },
              function(ret, err) {
                api.closeWidget({
                  id: "A6122368097326",
                  silent: true,
                });
              }
            );
            setTimeout(function() {
              _self.exitApp();
            }, 2000);
          } else {
            // history.back(-1);
            console.log("back:", _self.includes);
            _self.$router.goBack();
            // if (global.isApp) {
            // 	api.closeFrame({
            // 		name: 'banner',
            // 	})
            // }
          }
        }
      );
    },
  },
};



// WEBPACK FOOTER //
// ./src/App.vue